/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import {
  selectCommentsInCountStat,
  selectCommentsOutCountStat,
  selectAvatarPath,
  selectRating
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

class RightSidebarMyPage extends Component {
  render() {
    const ratingDesc = `${t('Рейтинг')}: ${
      this.props.rating.ratingStatusPoints
    }/${this.props.rating.ratingStatusPointsTo} (${
      this.props.rating.ratingStatusTitle
    })`;
    return (
      <div className="page-sidebar-sticky">
        <div className="page-sidebar-sticky-wrp">
          <div
            className="panel-group panel-group-side"
            id="panelGroupFilter"
            role="tablist"
            aria-multiselectable="true"
          >
            <div className="panel panel-default border-b text-center">
              <div className="panel-body">
                <img
                  alt=""
                  className="avatar avatar-responsive avatar_bordered"
                  src={this.props.avatarPath}
                />
                <div
                  className="label label-light label-success label_block text-overflow m-t-10"
                  data-toggle="tooltip"
                  data-container="body"
                  data-placement="top"
                  title={ratingDesc}
                >
                  <i
                    className={
                      this.props.rating.rating >= 20
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />
                  <i
                    className={
                      this.props.rating.rating >= 40
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />
                  <i
                    className={
                      this.props.rating.rating >= 60
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />
                  <i
                    className={
                      this.props.rating.rating >= 80
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />
                  <i
                    className={
                      this.props.rating.rating >= 100
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />{' '}
                  {this.props.rating.ratingStatusTitle}
                </div>
                <NavLink
                  to={`${this.context.router.route.location.pathname}/change-avatar`}
                  className="btn btn-muted btn-block btn-sm m-t-10"
                >
                  {t('Изменить аватар')}
                </NavLink>
              </div>
            </div>
            <NavLink
              to="/main/update-account/anketa"
              activeClassName="active"
              className="list-group-item"
            >
              <span className="list-group-item-val text-overflow">
                {t('Редактировать анкету')}
              </span>
            </NavLink>
            <NavLink
              to="/main/update-account/profile"
              activeClassName="active"
              className="list-group-item"
            >
              <span className="list-group-item-val text-overflow">
                {t('Настройка профиля')}
              </span>
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}

RightSidebarMyPage.contextTypes = {
  router: PropTypes.shape()
};

RightSidebarMyPage.propTypes = {
  avatarPath: PropTypes.string.isRequired,
  rating: PropTypes.shape({
    rating: PropTypes.string.isRequired,
    ratingStatusTitle: PropTypes.string.isRequired,
    ratingStatusPoints: PropTypes.number.isRequired,
    ratingStatusPointsTo: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  avatarPath: selectAvatarPath(state),
  rating: selectRating(state),
  commentsInCountStat: selectCommentsInCountStat(state),
  commentsOutCountStat: selectCommentsOutCountStat(state)
});

export default withRouter(connect(mapStateToProps)(RightSidebarMyPage));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/UpdateAccount/RightSidebarUpdAccount/RightSidebarMyPage.js